import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUser } from "../services/userSlice";
import "../styles/usermenu.css";

const Usermenu = () => {
  const user = useSelector(selectUser);
  let name: string = user?.displayName;
  return (
    <div className="userMenu">
      <div className="nav-user-name-container">
        <p>{name.charAt(0)}</p>
        <h4>{name}</h4>
      </div>
      <ul>
        <h4>My Learning</h4>
        <li>
          <Link to="/allcourses">All Courses</Link>
        </li>
        <li>
          <Link to="/inprogress">In Progress</Link>
        </li>
        <li>
          <Link to="/completed">Completed</Link>
        </li>
        <li>
          <Link to="/wishlist">Wishlist</Link>
        </li>
        <li>
          <Link to="/myaccount">My Account</Link>
        </li>
      </ul>

      <ul>
        <h4>Main Menu</h4>
        <li>
          <Link to="/courses">Courses</Link>
        </li>
        <li>
          <Link to="/plans">Plans</Link>
        </li>
        <li>
          <Link to="/categories">Categories</Link>
        </li>
        <li>
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
    </div>
  );
};

export default Usermenu;
